
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submission-success",
      function () {
        return require("private-next-pages/submission-success.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submission-success"])
      });
    }
  